import { CaptureStatus, Item, OrderDetails, RefundStatus } from '@nemuru-eng/js-api-client';

import { ItemStatusType } from '@/components/modules/Cart/components/OrderLines/types/ItemStatusType';

import { StatusTagType } from '../../../../../../config/types';
import { ItemStatus } from '../types/ItemStatus';

export const STATUS_COLOR = {
  [ItemStatus.PENDING_CAPTURE]: StatusTagType.WARNING,
  [ItemStatus.CAPTURED]: StatusTagType.SUCCESS,
  [ItemStatus.REFUNDED]: StatusTagType.DEFAULT,
};

export const useOrderDetails = (orderDetails: OrderDetails) => {
  const getOrderItemStatus = (item: Item): ItemStatusType => {
    let orderItemStatus: { status: ItemStatus; statusColor: StatusTagType } = {
      status: ItemStatus.PENDING_CAPTURE,
      statusColor: STATUS_COLOR[ItemStatus.PENDING_CAPTURE],
    };

    //REFUNDS
    orderDetails.refunds
      .filter((refund) => [RefundStatus.APPROVED, RefundStatus.CONFIRMED].includes(refund.status))
      .forEach((refund) => {
        if (refund.itemIds.some((orderLineId) => orderLineId === item.id)) {
          orderItemStatus = {
            status: ItemStatus.REFUNDED,
            statusColor: STATUS_COLOR[ItemStatus.REFUNDED],
          };
        }
      });
    //CAPTURES
    orderDetails.captures
      .filter((capture) => [CaptureStatus.APPROVED, CaptureStatus.CONFIRMED].includes(capture.status))
      .forEach((capture) => {
        if (capture.itemIds.some((orderLineId) => orderLineId === item.id)) {
          orderItemStatus = {
            status: ItemStatus.CAPTURED,
            statusColor: STATUS_COLOR[ItemStatus.CAPTURED],
          };
        }
      });
    //DEFAULT
    if (orderDetails.captures.length === 0) {
      return (orderItemStatus = {
        status: ItemStatus.PENDING_CAPTURE,
        statusColor: STATUS_COLOR[ItemStatus.PENDING_CAPTURE],
      });
    }
    return orderItemStatus;
  };

  return { getOrderItemStatus };
};
